<template>
  <div class="date-container d-flex align-items-center" @click="showPopup" >
    <input
      :value="currentValue"
      class="w-100 m-0 input-group-alternative form-control-sm input-height"
      disabled
    />
    <div class="position-absolute" style="inset:0" @click="showPopup" >
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      currentValue: null,
    };
  },
  methods: {
    showPopup() {
      this.params.showParentFilter();
    },
    onParentModelChanged(parentModel) {
      if(parentModel) {
        this.currentValue = parentModel.week;
      } else {
        this.currentValue = null;
      }
    },

  },
};
</script>

<style scoped>
.date-container {
  position: relative;
  width: 100%;
  .form-control:disabled,
  .form-control[readonly] {
    background-color: white;
  }
  .form-control-sm {
    height:24px !important;
    font-size: 11px;
  }
}
</style>
